export const userRoutes = [
  {
    path: '/',
    load: () => new Promise((resolve, reject) => {
      resolve(
        require('./home'));
    }),
  },
  {
    path: '/contact',
    load: () => new Promise((resolve, reject) => {
      resolve(
        require('./contact'));
    }),
  },
  {
    path: '/about',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./about'));
    }),
  },
  {
    path: '/become-a-pro',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./become-a-pro'));
    }),
  },
  {
    path: '/become-a-company',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./become-a-company'));
    }),
  },
  {
    path: '/post-a-project',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./post-a-project'));
    }),
  },
  {
    // B2B landing: the destination for property-manager outreach (calls/emails/PMI).
    path: '/property-managers',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./property-managers'));
    }),
  },
  {
    // Client-side Custom Projects: my posted projects + compare/accept quotes.
    // Logged-out callers see an inline phone+OTP gate (same auth as post-a-project).
    path: '/my-projects',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./my-projects'));
    }),
  },
  {
    // Company-side Custom Projects: marketplace + project detail/quote + my quotes.
    // Gated to logged-in, KYB-approved companies (else -> CompanyAuth / become-a-company).
    path: '/company/projects',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./company-projects'));
    }),
  },
  {
    path: '/company/quotes',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./company-projects'));
    }),
  },
  {
    // Company account section: referral, services, payout bank, legal, delete.
    path: '/company/account',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./company-account'));
    }),
  },
  {
    path: '/get-app',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./get-app'));
    }),
  },
  {
    path: '/privacy',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./legal')); // premium Privacy Policy (alias -> /privacy-policy content)
    }),
  },
  {
    path: '/login',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./login'));
    }),
  },
  {
    path: '/support',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./support'));
    }),
  },
  {
    path: '/faq',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./faq'));
    }),
  },
  {
    // COMPLIANCE: serve the counsel-approved premium policy here (Play flagged the old CMS stub as
    // invalid). Aliased to 'privacy-policy' in legal/content.js; the pro app opens this URL.
    path: '/partner/privacy-policy',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./legal'));
    }),
  },

  {
    path: '/user',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./static/user'));
    }),
  },
  {
    path: '/partner',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./static/partner'));
    }),
  },
  {
    path: '/category',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./category'));
    }),
  },
  {
    // Logged-out guest review screen (approach B). Open route; the guest fills description/schedule/
    // matching here and only authenticates + pays on the final CTA.
    path: '/order-review',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./order-review'));
    }),
  },
  {
    path: '/legal',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./static/legal'));
    }),
  },
  {
    path: '/dashboard',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./dashboard'));
    }),
  },
  {
    path: '/order/:id',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./booking'));
    }),
  },
  {
    path: '/bookings/:type',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./bookings'));
    }),
  },
  {
    path: '/job-notifications',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./jobNotifications'));
    }),
  },
  {
    path: '/payment-method',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./paymentMethod'));
    }),
  },
  {
    path: '/profile',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./profile'));
    }),
  },
  {
    path: '/saved-addresses',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./savedAddresses'));
    }),
  },
  {
    path: '/settings',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./settings'));
    }),
  },
  {
    path: '/senior-veteran-discount',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./community-discount'));
    }),
  },
  {
    path: '/notifications',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./notifications'));
    }),
  },
  {
    path: '/trusted-contacts',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./trustedContacts'));
    }),
  },
  {
    path: '/delete-account',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./deleteAccount'));
    }),
  },
  {
    // CCPA/CPRA — authenticated client Data Rights self-service (access/correct/delete + status).
    path: '/data-rights',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./dataRights'));
    }),
  },
  {
    // CCPA/CPRA §1798.135 — public "Do Not Sell or Share My Personal Information" disclosure + opt-out.
    path: '/do-not-sell',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./doNotSell'));
    }),
  },
  {
    path: '/tracking/:id',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./tracking'));
    }),
  },
  {
    path: '/chat-message/:id',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./chatMessage'));
    }),
  },
  {
    path: '/booking/:id',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./book'));
    }),
  },
  {
    path: '/add-wallet',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./addWallet'));
    }),
  },
  {
    path: '/add-card',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./addCard'));
    }),
  },
  {
    path: '/terms-of-service',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./legal')); // premium Terms of Service (alias -> /terms content)
    }),
  },
  {
    path: '/services/:service',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./seoService'));
    }),
  },
  {
    path: '/pro/:id',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./pro'));
    }),
  },
  {
    path: '/services/:service/:cityState',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./seoLanding'));
    }),
  },
  {
    path: '/leave-a-review',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./leave-a-review'));
    }),
  },
  {
    // PUBLIC mobile photo-handoff page. A desktop client (no camera) opens a
    // photo-handoff session, shows its QR; the phone scans -> lands here ->
    // captures photos -> they flow back to the PC session. Registered BEFORE
    // the admin catch-all /:pageUrl so the real page wins.
    path: '/m/photos/:sessionId',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./mobile-photos'));
    }),
  },
  // New additive marketing pages — registered BEFORE the legal spread (which also lists /how-it-works)
  // and BEFORE the admin catch-all /:pageUrl, so these real pages win.
  {
    path: '/how-it-works',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./how-it-works'));
    }),
  },
  {
    path: '/trust-safety',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./trust-safety'));
    }),
  },
  {
    path: '/pricing',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./pricing'));
    }),
  },
  // SEO B2.3 — competitor "alternative" comparison pages (/compare/taskrabbit-alternative, etc.)
  {
    path: '/compare/:slug',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./compare'));
    }),
  },
  // SEO B2.4 — cost guides / how-to blog (/guides index + /guides/:slug articles).
  {
    path: '/guides',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./guides'));
    }),
  },
  {
    path: '/guides/:slug',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./guides'));
    }),
  },
  // P2 additive marketing pages — registered BEFORE the admin catch-all /:pageUrl so these real pages win.
  // (folder is services-hub to avoid clashing with the /services/:service seoService route.)
  {
    path: '/services',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./services-hub'));
    }),
  },
  // SEO regional-focus — city "Home Services" pillar hubs (/home-services/philadelphia, etc.).
  // Registered BEFORE the admin catch-all /:pageUrl so these real pages win.
  {
    path: '/home-services/:citySlug',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./homeServices'));
    }),
  },
  {
    path: '/help',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./help'));
    }),
  },
  {
    path: '/reviews',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./reviews'));
    }),
  },
  // P3 additive growth/marketing pages — registered BEFORE the admin catch-all /:pageUrl so these real
  // pages win. (business = B2B landing; gift-cards/blog are honest "coming soon" pages.)
  {
    path: '/business',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./business'));
    }),
  },
  {
    path: '/gift-cards',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./gift-cards'));
    }),
  },
  {
    path: '/careers',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./careers'));
    }),
  },
  {
    path: '/blog',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./blog'));
    }),
  },
  // Premium hand-built legal/business pages — must be registered BEFORE the admin catch-all /:pageUrl.
  ...[
    '/terms', '/terms-of-service', '/privacy-policy', '/privacy', '/refunds',
    '/independent-contractor', '/background-check', '/peace-of-mind-protection', '/sms-consent',
    '/about-besthand', '/how-it-works', '/trust-and-safety', '/contact-us',
    // A11Y: accessibility statement (WCAG 2.1 AA) — premium legal/content page.
    '/accessibility',
    // Large Projects legal supplement (companies, escrow, lien waivers, KYB).
    '/large-projects-terms', '/company-terms',
  ].map((p) => ({
    path: p,
    load: () => new Promise((resolve, reject) => {
      resolve(require('./legal'));
    }),
  })),
  {
    path: '/:pageUrl',
    load: () => new Promise((resolve, reject) => {
      resolve(require('./page'));
    }),
  },
];